import React from "react";
import { Resizable } from "react-resizable";

const ColumnResizable = (props) => {
    const { onResize, width, onClick, ...restProps } = props;

    if (!width) {
        return <th {...restProps} />;
    }

    return (
        <Resizable
            width={width}
            height={0}
            handle={
                <span
                    className="react-resizable-handle"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                />
            }
            onResize={onResize}
            onClick={e => {
                // trigger column sort - (click) if element click are div.ant-table-column-sorters and span.ant-table-column-title
                if (e.target.classList.contains('ant-table-column-sorters') || e.target.classList.contains('ant-table-column-title')) {
                    onClick(e);
                }
            }}
            draggableOpts={{ enableUserSelectHack: false }}
        >
            <th {...restProps} />
        </Resizable>
    );
};

export default ColumnResizable;